class Order {
    constructor(id, total_price, date, payment_method_id, shipped, shipping_paid) {
        this.id = id;
        this.total_price = total_price;
        this.date = date;
        this.payment_method_id = payment_method_id;
    }
}

class OrderItem {
    constructor(id, order_id, quantity, sold_price) {
        this.id = id;
        this.order_id = order_id;
        this.quantity = quantity;
        this.sold_price = sold_price;
    }
}

export {Order, OrderItem};